import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SaveOrCancel from './SaveOrCancel';
import { DIFFICULTY_LEVELS, PRICING_OPTIONS } from '../static-content';

import { COLORS } from '../styles/colors';

const FormContent = ({ nameType, editId, formData,
  expansionChange, formChange, priceSelectionChange,
  selectedPricingType, expand, workoutCats, FileSelection,
  isValidating, validateForm, showPricingInput, submitAction,
  Builder, onCancel, products, priceRange }) => {
  const PanelHeaderContent = ({ step }) => (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
      <div>
        <FontAwesomeIcon icon="chevron-right" style={{ marginRight: 5, color: COLORS.orange }} />
        Step {step}
      </div>
      <div>
        {
          step !== expand ? (
            <FontAwesomeIcon icon="edit" style={{ marginRight: 5, color: COLORS.orange }} />
          ) : null
        }
        {/* <a style={{color: COLORS.orange}}>
          <FontAwesomeIcon icon="search-plus" style={{marginRight: 5, color: COLORS.orange}}/>
        </a> */}
      </div>
    </div>
  );

  let updateProducts = Object.values(products);
  updateProducts = updateProducts.sort((a, b) => {
     return parseFloat(a.price) - parseFloat(b.price)
  })

  return (
    <div>

      <ExpansionPanel
        expanded={expand === 1}
        onChange={() => expansionChange(1)}>
        <ExpansionPanelSummary className="expand">
          <PanelHeaderContent step={1} />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Grid container style={{ padding: 10 }}>
            <Grid item xs={6}>
              <TextField
                label={`${nameType} Name`}
                value={formData.name}
                onChange={formChange('name')}
                margin="dense"
                variant="outlined"
                inputProps={{ maxLength: 60 }}
              />
            </Grid>
            <Grid item xs={3} style={{ paddingRight: 10, paddingLeft: 10 }}>
              <TextField
                select
                label="Pricing"
                value={selectedPricingType}
                onChange={priceSelectionChange()}
                margin="dense"
                variant="outlined"
              >
                {PRICING_OPTIONS.map(option => (
                  <MenuItem key={option.type} value={option.type}>
                    {option.text}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={3} >
              {
                showPricingInput ? (
                  <TextField
                    select
                    label="ie, $10.00"
                    value={formData.storeId}
                    onChange={priceRange('price')}
                    margin="dense"
                    variant="outlined"
                  >
                    {updateProducts.map(option => (
                      <MenuItem key={option._id} value={option.storeId}>
                        {`$${option.price}`}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : null
              }

            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description (Optional)"
                value={formData.description}
                onChange={formChange('description')}
                margin="dense"
                variant="outlined"
                multiline={true}
                inputProps={{ maxLength: 250 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                style={{ marginBottom: 0 }}
                select
                label="Difficulty"
                value={formData.level}
                onChange={formChange('level')}
                margin="dense"
                variant="outlined"
              >
                {DIFFICULTY_LEVELS.map(option => (
                  <MenuItem key={option.level} value={option.level}>
                    {option.text}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={4}
              style={{ paddingRight: 10, paddingLeft: 10 }}>
              <TextField
                style={{ marginBottom: 0 }}
                select
                label="Category"
                value={formData.categoryId}
                onChange={formChange('categoryId')}
                margin="dense"
                variant="outlined"
              >
                {Object.values(workoutCats).map(option => (
                  <MenuItem key={option._id} value={option._id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            { (nameType === 'Workout' || nameType === 'Program') &&
              <Grid item xs={4}
                style={{ paddingRight: 10, paddingLeft: 10 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={formChange('isFeatured')}
                      defaultChecked={formData.isFeatured}
                      inputProps={{
                        'name': 'isFeatured',
                      }}
                    />
                  }
                  name = "isFeatured"
                  label={`Featured ${nameType}`}
                  />
              </Grid>
            }
            <Grid item xs={12}>
                {FileSelection}
            </Grid>
          { (nameType === 'Workout' || nameType === 'Program') &&
            <React.Fragment>
            <Grid item xs={5} style={{ paddingRight: 0, paddingLeft: 0, marginTop: 20, textAlign: 'center' }}>
                <strong>OR</strong>
            </Grid>
            <Grid item xs={5} style={{ paddingRight: 0, paddingLeft: 0, marginTop: 20, textAlign: 'center' }}>
            </Grid>
            <br></br>
            <Grid item xs={5} style={{ paddingRight: 10, paddingLeft: 10, marginTop: 10 }}>
            <TextField
                label="YouTube Link"
                value={formData.youtubeLink}
                onChange={formChange('youtubeLink')}
                margin="dense"
                variant="outlined"
              />
            </Grid>
            </React.Fragment>
          }

            <Grid item xs={12}>
              <SaveOrCancel
                saveDisabled={isValidating}
                onSaveClick={() => expansionChange(2)}
                onCancelClick={onCancel}
              />

            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        expanded={expand === 2}
        onChange={() => expansionChange(2)}>
        <ExpansionPanelSummary>
          <PanelHeaderContent step={2} />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {Builder}
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <Button
        style={{ display: 'none' }}
        disabled={isValidating}
        onClick={validateForm}
        variant="contained"
        color="primary">
        {submitAction === 'edit' ? 'Update Workout' : 'Save Workout'}
      </Button>
    </div>
  )
}

export default FormContent



// WEBPACK FOOTER //
// ./src/components/FormContent.js